import { IMAGES } from "./images";

// Landing pages par secteur d'activité (intention de recherche : "enseigne restaurant", etc.)
export const SECTEURS = [
  {
    slug: "enseigne-restaurant",
    nav: "Restaurants",
    label: "Restaurants",
    image: IMAGES.storefrontNight,
    title: "Enseigne Restaurant Lumineuse | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse pour restaurant : enseigne drapeau, néon LED, lettres boîtiers et caisson. Fabrication et pose sur mesure, France & Suisse. Devis gratuit.",
    h1: "Enseignes lumineuses pour restaurants",
    overline: "Restauration",
    intro: [
      "Pour un restaurant, l'enseigne crée l'envie avant même la lecture du menu. Elle doit être chaleureuse le jour, séduisante le soir et parfaitement lisible depuis la rue pour capter les passants.",
      "Ronalp Enseigne conçoit, fabrique et installe des enseignes lumineuses adaptées à l'ambiance de votre établissement : bistrot, brasserie, restaurant gastronomique ou food court.",
    ],
    needs: [
      "Une visibilité forte le soir, moment clé de l'activité",
      "Une ambiance qui reflète la cuisine et le concept",
      "Une enseigne drapeau pour capter le flux piéton",
      "Des matériaux résistants aux terrasses et intempéries",
    ],
    solutions: ["enseigne-drapeau", "neon-led", "lettres-lumineuses", "caisson-lumineux", "vitrophanie"],
    examples: ["Enseigne drapeau double face", "Néon LED signature en vitrine", "Lettres boîtiers rétroéclairées", "Marquage de vitrine (menu, horaires)"],
    faq: [
      { q: "Quelle enseigne pour attirer les clients le soir ?", a: "Une enseigne lumineuse LED (lettres boîtiers ou néon) combinée à une enseigne drapeau offre une visibilité optimale la nuit, lorsque la fréquentation d'un restaurant est la plus forte." },
      { q: "Le néon LED convient-il à un restaurant ?", a: "Oui, le néon LED recrée une ambiance chaleureuse et tendance, parfaite en vitrine ou en intérieur, avec une faible consommation et aucun entretien complexe." },
    ],
    relatedLocales: ["enseigne-lumineuse-geneve", "enseigne-lumineuse-annecy", "enseigne-lumineuse-lyon"],
  },
  {
    slug: "enseigne-pharmacie",
    nav: "Pharmacies",
    label: "Pharmacies",
    image: IMAGES.commercial,
    title: "Enseigne Pharmacie & Croix Lumineuse | Fabrication – Ronalp Enseigne",
    metaDescription:
      "Enseigne de pharmacie : croix lumineuse, logo LED, lettres boîtiers et signalétique. Fabrication et pose aux normes, France & Suisse. Demandez votre devis.",
    h1: "Enseignes et croix lumineuses pour pharmacies",
    overline: "Santé",
    intro: [
      "La pharmacie doit être identifiable immédiatement, de jour comme de nuit, et inspirer confiance et propreté. Son enseigne combine généralement une croix lumineuse normée, le nom en lettres lumineuses et une signalétique claire.",
      "Nous fabriquons et installons des enseignes de pharmacie sobres, lisibles et durables, en respectant les usages de la profession.",
    ],
    needs: [
      "Une identification immédiate et rassurante",
      "Une lisibilité parfaite de jour comme de nuit",
      "Une image de propreté et de sérieux",
      "Une signalétique claire des services (garde, parapharmacie)",
    ],
    solutions: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "signaletique", "vitrophanie"],
    examples: ["Nom en lettres boîtiers LED", "Caisson lumineux logo", "Signalétique parapharmacie", "Vitrophanie services & horaires"],
    faq: [
      { q: "Quelle enseigne pour une pharmacie ?", a: "Un ensemble cohérent : le nom en lettres boîtiers ou caisson lumineux, un logo LED et une signalétique claire. L'éclairage en blanc neutre renforce l'image de propreté et de confiance." },
      { q: "Fournissez-vous la croix de pharmacie ?", a: "Nous intégrons votre enseigne complète ; la croix lumineuse normée peut être intégrée au projet selon vos besoins et la réglementation locale." },
    ],
    relatedLocales: ["enseigne-lumineuse-lausanne", "enseigne-lumineuse-geneve", "enseigne-lumineuse-pays-de-gex"],
  },
  {
    slug: "enseigne-hotel",
    nav: "Hôtels",
    label: "Hôtels",
    image: IMAGES.facade,
    title: "Enseigne Hôtel Lumineuse | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse pour hôtel : enseigne de toiture, lettres relief, totem et signalétique. Fabrication et pose premium, France & Suisse. Devis gratuit.",
    h1: "Enseignes lumineuses pour hôtels",
    overline: "Hôtellerie",
    intro: [
      "Un hôtel doit être repéré de loin, souvent depuis une route ou une avenue, tout en projetant une image à la hauteur de son standing. L'enseigne participe pleinement à la première impression du client.",
      "Nous réalisons des enseignes d'hôtel visibles et élégantes : enseignes de toiture, lettres relief haut de gamme, totems et signalétique d'accueil.",
    ],
    needs: [
      "Une visibilité à distance, depuis la route",
      "Une image premium cohérente avec le standing",
      "Une signalétique d'accueil et de direction claire",
      "Une enseigne fonctionnant toute la nuit",
    ],
    solutions: ["enseigne-lumineuse", "lettres-relief", "totem-publicitaire", "signaletique", "habillage-facade"],
    examples: ["Enseigne de toiture lumineuse", "Lettres relief en inox", "Totem d'entrée", "Signalétique d'accueil multilingue"],
    faq: [
      { q: "Quelle enseigne pour un hôtel visible de la route ?", a: "Une enseigne de toiture ou un totem lumineux assurent une visibilité à grande distance, complétés par des lettres relief premium sur la façade d'entrée." },
      { q: "Proposez-vous une signalétique d'accueil pour hôtels ?", a: "Oui, de la plaque directionnelle à la signalétique d'étage, souvent multilingue pour une clientèle internationale." },
    ],
    relatedLocales: ["enseigne-lumineuse-geneve", "enseigne-lumineuse-annecy", "enseigne-lumineuse-lausanne"],
  },
  {
    slug: "enseigne-concession-automobile",
    nav: "Concessions auto",
    label: "Concessions automobiles",
    image: IMAGES.storefront2,
    title: "Enseigne Concession Automobile & Totem | Ronalp Enseigne",
    metaDescription:
      "Enseigne pour concession automobile : totem de marque, habillage de façade, caisson lumineux et grand format. Fabrication et pose, France & Suisse.",
    h1: "Enseignes et totems pour concessions automobiles",
    overline: "Automobile",
    intro: [
      "Une concession automobile se situe souvent en bord de route ou en zone d'activité : l'enjeu est d'être visible de loin et de respecter la charte de la marque. Totems, habillages de façade et grands formats sont au cœur du dispositif.",
      "Nous concevons et installons l'ensemble de la signalétique d'une concession, du totem d'entrée à l'habillage complet du bâtiment.",
    ],
    needs: [
      "Une visibilité routière forte",
      "Le respect strict de la charte constructeur",
      "Des surfaces d'expression importantes (façade, totem)",
      "Une signalétique de site (showroom, atelier, livraison)",
    ],
    solutions: ["totem-publicitaire", "habillage-facade", "caisson-lumineux", "impression-grand-format", "signaletique-exterieure"],
    examples: ["Totem de marque lumineux", "Habillage de façade composite", "Caisson lumineux showroom", "Signalétique directionnelle de site"],
    faq: [
      { q: "Pouvez-vous respecter la charte d'un constructeur ?", a: "Oui, nous fabriquons selon les cahiers des charges constructeurs (couleurs, formes, matériaux) pour une conformité totale à la charte de marque." },
      { q: "Réalisez-vous les totems en bord de route ?", a: "Oui, totems lumineux avec étude de fondation, levage et raccordement, dimensionnés pour la visibilité routière." },
    ],
    relatedLocales: ["enseigne-lumineuse-saint-genis-pouilly", "enseigne-lumineuse-lyon", "enseigne-lumineuse-haute-savoie"],
  },
  {
    slug: "enseigne-garage",
    nav: "Garages",
    label: "Garages",
    image: IMAGES.workshopWelding,
    title: "Enseigne Garage & Signalétique Atelier | Ronalp Enseigne",
    metaDescription:
      "Enseigne pour garage automobile : caisson lumineux, lettres LED et signalétique d'atelier robuste. Fabrication et pose durable, France & Suisse.",
    h1: "Enseignes pour garages et ateliers",
    overline: "Garage & réparation",
    intro: [
      "Un garage a besoin d'une enseigne robuste, lisible et immédiatement compréhensible, ainsi que d'une signalétique d'atelier pratique et durable face à un environnement exigeant.",
      "Nous réalisons des enseignes et signalétiques solides pour garages, centres auto et ateliers de réparation.",
    ],
    needs: [
      "Une enseigne résistante et facile d'entretien",
      "Une identification claire des services proposés",
      "Une signalétique d'atelier et de sécurité",
      "Un bon rapport visibilité / budget",
    ],
    solutions: ["caisson-lumineux", "enseigne-lumineuse", "signaletique-exterieure", "marquage-vehicule", "impression-grand-format"],
    examples: ["Caisson lumineux de façade", "Signalétique zones atelier", "Marquage des véhicules de prêt", "Panneaux de services & tarifs"],
    faq: [
      { q: "Quelle enseigne résiste le mieux pour un garage ?", a: "Un caisson lumineux en aluminium et plexiglas offre robustesse, lisibilité et facilité d'entretien, idéal pour un environnement d'atelier." },
      { q: "Faites-vous le marquage des véhicules de prêt ?", a: "Oui, nous équipons vos véhicules de prêt ou de service aux couleurs du garage pour renforcer votre visibilité." },
    ],
    relatedLocales: ["enseigne-lumineuse-ain", "enseigne-lumineuse-annemasse", "enseigne-lumineuse-lyon"],
  },
  {
    slug: "enseigne-commerce",
    nav: "Commerces",
    label: "Commerces",
    image: IMAGES.commercial,
    title: "Enseigne Commerce Lumineuse | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse pour commerce : lettres boîtiers, caisson, enseigne drapeau et vitrophanie. Fabrication et pose sur mesure, France & Suisse. Devis gratuit.",
    h1: "Enseignes lumineuses pour commerces",
    overline: "Commerce & boutique",
    intro: [
      "Pour un commerce, l'enseigne est l'outil de visibilité numéro un : elle attire le regard, affirme votre identité et déclenche l'entrée en boutique. Elle doit se démarquer dans un environnement souvent concurrentiel.",
      "Nous créons des enseignes de commerce sur mesure, de la boutique de centre-ville au magasin de zone commerciale, avec la vitrophanie assortie.",
    ],
    needs: [
      "Se démarquer des commerces voisins",
      "Attirer le flux piéton et automobile",
      "Une image de marque cohérente (enseigne + vitrine)",
      "Une solution adaptée au centre-ville comme à la zone commerciale",
    ],
    solutions: ["enseigne-lumineuse", "lettres-boitiers", "enseigne-drapeau", "vitrophanie", "marquage-vitrine"],
    examples: ["Lettres boîtiers de façade", "Enseigne drapeau de rue", "Marquage de vitrine saisonnier", "Caisson lumineux de bandeau"],
    faq: [
      { q: "Quelle enseigne choisir pour un commerce ?", a: "Des lettres boîtiers LED pour la façade, complétées d'une enseigne drapeau pour les piétons et d'une vitrophanie pour animer la vitrine : un trio efficace pour la plupart des commerces." },
      { q: "Intervenez-vous pour les petits commerces indépendants ?", a: "Oui, nous accompagnons aussi bien les commerces indépendants que les réseaux, avec des solutions adaptées à chaque budget." },
    ],
    relatedLocales: ["enseigne-lumineuse-pays-de-gex", "enseigne-lumineuse-geneve", "enseigne-lumineuse-annecy"],
  },
];

export const SECTEURS_BY_SLUG = Object.fromEntries(SECTEURS.map((s) => [s.slug, s]));
export const getSecteur = (slug) => SECTEURS_BY_SLUG[slug];
